import { useContext } from 'react';
import { FeatureServicesProvider } from '../provider/feature-services-provider';
const getLanguageIdentifier = (marketConfig) => `${marketConfig.language}-${marketConfig.market}`;
export const FORMATTER_DEFAULT = (marketConfig) => {
    const { numberFormatterService } = useContext(FeatureServicesProvider);
    const caeFormatter = new Intl.NumberFormat(getLanguageIdentifier(marketConfig), {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    });
    const currency = numberFormatterService === null || numberFormatterService === void 0 ? void 0 : numberFormatterService.formatCurrency(0).replace(/\d[\d\W]*\d/g, '');
    return {
        formatConsumption: (value) => {
            if (typeof value !== 'number')
                return '';
            return caeFormatter.format(value);
        },
        formatPrice: (price) => {
            var _a;
            if (typeof price !== 'number')
                return null;
            return (_a = numberFormatterService === null || numberFormatterService === void 0 ? void 0 : numberFormatterService.formatCurrency(price)) !== null && _a !== void 0 ? _a : null;
        },
        currency: () => {
            return currency !== null && currency !== void 0 ? currency : '';
        },
    };
};
